import { createSelector } from '@reduxjs/toolkit'

import { GROUP_ADMIN_ROLE, GROUP_MEMBER_ROLE } from '../constants'
import { userGroupSelector } from '../group_management/selectors'
import { hasRoleInGroup } from '../helpers/has_role_in_group'

const sliceSelector = (state) => state.userGroups.management.users
const membersSliceSelector = createSelector(sliceSelector, (slice) => slice.members)
const selectedIdsSelector = createSelector(membersSliceSelector, ({ selectedMembers }) => selectedMembers.map(({ id }) => id))
export const membersSelector = createSelector(
  membersSliceSelector,
  selectedIdsSelector,
  ({ entities }, selectedIds) => entities.map((member) => ({
    ...member,
    is_selected: selectedIds.includes(member.id)
  }))
)
export const selectedMembersCountSelector = createSelector(
  membersSliceSelector,
  ({ selectedMembers }) => selectedMembers.length
)
export const paginationSelector = createSelector(membersSliceSelector, ({ pagination }) => pagination)
export const filterSelector = createSelector(membersSliceSelector, ({ filter }) => filter)
export const sortFieldSelector = createSelector(membersSliceSelector, ({ sortField }) => sortField)
export const sortOrderSelector = createSelector(membersSliceSelector, ({ sortOrder }) => sortOrder)
export const isDataLoadingSelector = createSelector(membersSliceSelector, ({ isLoading }) => isLoading)
export const isRemovePopupOpenSelector = createSelector(sliceSelector, (slice) => slice.removePopup.isOpen)
export const removePopupMembersSelector = createSelector(sliceSelector, (slice) => slice.removePopup.members)
export const removePopupRoleSelector = createSelector(sliceSelector, (slice) => slice.removePopup.role)
export const removePopupPendingSelector = createSelector(sliceSelector, (slice) => slice.removePopup.pending)

const isSelectionGroupAdminOnly = (member, userGroup) => hasRoleInGroup(member, GROUP_ADMIN_ROLE, userGroup)
    && !hasRoleInGroup(member, GROUP_MEMBER_ROLE, userGroup)

export const batchCheckboxStatusSelector = createSelector(
  membersSelector, userGroupSelector,
  (members, userGroup) => {
    const selectedMembersCount = members.filter((member) => member.is_selected).length
    if (selectedMembersCount === 0) {
      return 'none'
    }
    const groupAdminsCount = members.filter((member) => isSelectionGroupAdminOnly(member, userGroup)).length
    if (selectedMembersCount === (members.length - groupAdminsCount)) {
      return 'all'
    }
    return 'some'
  }
)
